<template>
  
  <span>

      <v-app-bar
        app
        color="secondary"
        elevate-on-scroll
        dark
      >
        
        <!-- class="hidden-lg-and-up" -->

        <v-app-bar-nav-icon @click="drawer = true" v-if="isTemporary"></v-app-bar-nav-icon>

        <v-toolbar-title>Realtime.report</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            
            <v-btn icon @click="switch_company" v-on="on">
                <v-icon>mdi-domain</v-icon>
            </v-btn>

          </template>
          <span>{{ $t("Select an account") }}</span>
        </v-tooltip>
        
        <v-select
        :items="getLocales()"
        v-model="app.locale"
        @change="setLocale"
        label="Language"
        solo
        hide-details
        style="max-width:100px;"
        ></v-select>

        <v-progress-linear
          v-if="loader"
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="primary"
        ></v-progress-linear>

      </v-app-bar>

      <!-- class="hidden-lg-and-up" -->

      <v-navigation-drawer
        v-model="drawer"
        absolute
        :temporary="isTemporary"
        >

        <div class="text-center pa-8 pb-0 mt-lg-12 mt-xl-12">
          <img style="width:120px;" src="https://storage.googleapis.com/realtime-reporter-static/images/realtimereport-color.svg">
        </div>

        <v-list
            nav
            dense
        >
            <v-divider></v-divider>

            <v-list-item two-line  class="pt-0 mb-0"  to="/profile">

                <v-list-item-avatar>
                  
                  <v-avatar color="primary" size="36">
                    <v-icon dark>mdi-account</v-icon>
                  </v-avatar>

                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>{{ currentUser.displayName }}</v-list-item-title>
                  <v-list-item-subtitle>{{ currentCompany.name }}</v-list-item-subtitle>
                </v-list-item-content>

            </v-list-item>

            <v-divider></v-divider>

            <v-list-item-group>

            <v-list-item :to="menu.to" v-for="menu in app.mainMenu" :key="menu.title">
                <v-list-item-icon>
                <v-icon>{{ menu.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ menu.title }}</v-list-item-title>
            </v-list-item>

            <v-list-item @click="signOut();">
                <v-list-item-icon>
                <v-icon>mdi-label-off-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ $t('Logout') }}</v-list-item-title>
            </v-list-item>

            </v-list-item-group>

        </v-list>
        
    </v-navigation-drawer>

    <!-- <v-navigation-drawer
        class="hidden-md-and-down"
        absolute
        >

        <div class="text-center pa-8 pb-0 mt-lg-12 mt-xl-12">
          <img style="width:120px;" src="https://storage.googleapis.com/realtime-reporter-static/images/realtimereport-color.svg">
        </div>

        <v-list
            nav
            dense
        >
            <v-divider></v-divider>

            <v-list-item two-line  class="pt-0 mb-0" to="/profile">

                <v-list-item-avatar>
                  
                  <v-avatar color="primary" size="36">
                    <v-icon dark>mdi-account</v-icon>
                  </v-avatar>

                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>{{ currentUser.displayName }}</v-list-item-title>
                  <v-list-item-subtitle>{{ currentCompany.name }}</v-list-item-subtitle>
                </v-list-item-content>

            </v-list-item>

            <v-divider></v-divider>

            <v-list-item-group>

            <v-list-item :to="menu.to" v-for="menu in app.mainMenu" :key="menu.title">
                <v-list-item-icon>
                <v-icon>{{ menu.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ menu.title }}</v-list-item-title>
            </v-list-item>

            <v-list-item @click="signOut();">
                <v-list-item-icon>
                <v-icon>mdi-label-off-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Logout</v-list-item-title>
            </v-list-item>

            </v-list-item-group>

        </v-list>
        
    </v-navigation-drawer> -->

  </span>

</template>

<script>

import helpers from "@/helpers";
import { mapGetters } from "vuex";

export default {
  name: 'Header',

  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      currentUser: "user/current",
      currentCompany: "companies/currentCompany",
      loader: "app/loader",
      app: "app/data",
    }),
  },
  
  components: {
  },
  data: () => ({
      drawer: false,
      temporary: false,
      loading: true,
      isTemporary: true
  }), 
  methods: {
    signOut() {
      helpers.signOut();
    },
    getLocales(){
      return ['nl','en'] ;
    },
    setLocale(){

      console.log('SetLocale'+this.app.locale); 
      this.$i18n.locale = this.app.locale ;
      this.$store.commit('app/setLocale', this.app.locale) ;

    },
    switch_company(){
      this.$store.commit('companies/setCompany', null) ; 
    },
    updateTemporary(){

      if(window.innerWidth > 1264){
        this.isTemporary = false ;
        this.drawer = true ;
      }else if(this.isTemporary != true){
        this.isTemporary = true ;
        this.drawer = false ;
      }

    },
  },

  destroyed() {
    window.removeEventListener("resize", this.updateTemporary);
  },

  created() {
    this.updateTemporary();
    window.addEventListener("resize", this.updateTemporary);
  }

};
</script>
